import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../lib/firebase.js";

/* Subscribe to a single Firestore document. Returns { data, loading, error }.
   `data` includes the document id as `id`. Null when the doc does not exist. */
export function useDoc(collectionName, docId) {
  const [state, setState] = useState({ data: null, loading: true, error: null });

  useEffect(() => {
    if (!docId) {
      setState({ data: null, loading: false, error: null });
      return;
    }
    setState((s) => ({ ...s, loading: true }));
    const ref = doc(db, collectionName, docId);
    const unsub = onSnapshot(
      ref,
      (snap) => {
        setState({
          data: snap.exists() ? { id: snap.id, ...snap.data() } : null,
          loading: false,
          error: null,
        });
      },
      (error) => {
        console.error(`[useDoc] ${collectionName}/${docId}`, error);
        setState({ data: null, loading: false, error });
      }
    );
    return unsub;
  }, [collectionName, docId]);

  return state;
}
